import { useCallback, useState } from 'react';
import { SortIconState, TableSummaryBySchoolData } from '../../model';

type TableSummaryBySchoolDataType = keyof TableSummaryBySchoolData;

export const useSorter = (rows: TableSummaryBySchoolData[], fields: TableSummaryBySchoolDataType[]) => {
	const [activeSorting, setActiveSorting] = useState('');
	const [sortState, setSortState] = useState(SortIconState.inactive);
	const onClick = useCallback(
		(fieldName: TableSummaryBySchoolDataType) => {
			return () => {
				if (fieldName !== activeSorting) {
					setActiveSorting(fieldName);
					setSortState(SortIconState.ascending);
				} else if (sortState === SortIconState.ascending) {
					setSortState(SortIconState.descending);
				} else {
					setActiveSorting('');
					setSortState(SortIconState.inactive);
				}
			};
		},
		[activeSorting, sortState],
	);
	const sortRows =
		sortState === SortIconState.inactive
			? [...rows]
			: [...rows].sort((a, b) => {
					const field = activeSorting as TableSummaryBySchoolDataType;
					const fieldA = a[field] || '';
					const fieldB = b[field] || '';
					return fieldA < fieldB
						? sortState === SortIconState.descending
							? -1
							: 1
						: fieldA > fieldB
						? sortState === SortIconState.descending
							? 1
							: -1
						: 0;
			  });
	const fieldValue = fields.reduce<
		{
			[k in TableSummaryBySchoolDataType]?: { state: SortIconState; onClick: () => void };
		}
	>((acc, el: TableSummaryBySchoolDataType) => {
		const handleClick = onClick(el);
		return {
			...acc,
			[el]: {
				state: activeSorting !== el ? SortIconState.inactive : sortState,
				onClick: handleClick,
			},
		};
	}, {});
	return { sortRows, ...fieldValue };
};
